import { render, staticRenderFns } from "./HoverList.vue?vue&type=template&id=486bbc7a&scoped=true&"
import script from "./HoverList.vue?vue&type=script&lang=js&"
export * from "./HoverList.vue?vue&type=script&lang=js&"
import style0 from "./HoverList.vue?vue&type=style&index=0&id=486bbc7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486bbc7a",
  null
  
)

export default component.exports